export const cardViewEnums = {
    GRID: 'GRID',
    LIST: 'LIST',
};
